import loadScriptAsync from './loadScriptAsync'

export default async function loadTestografAsync() {
  const { success } = await loadScriptAsync(
    'https://www.testograf.ru/embed/embed.js?v=1737977365'
  )
  return success
}
